import { render, staticRenderFns } from "./gameSelector.vue?vue&type=template&id=21441095&scoped=true"
import script from "./gameSelector.vue?vue&type=script&lang=js"
export * from "./gameSelector.vue?vue&type=script&lang=js"
import style0 from "./gameSelector.vue?vue&type=style&index=0&id=21441095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21441095",
  null
  
)

export default component.exports